import React from 'react';

const EvenFour = ()=> {
    return (

        <React.Fragment>
            <div className="vertCol3_w3 col1"></div>
            <div className="vertCol3_w3 col2"></div>
            <div className="vertCol3_w3 col3"></div>
            <div className="vertCol3_w3 frame1"></div>
            <div className="vertCol3_w3 frame2"></div>
            <div className="vertCol3_w3 frame3"></div>
            <div className="vertCol3_w3 frame4"></div>
        </React.Fragment>
    )
}

export default EvenFour;